export const collapsedLinkClass = 'pdp_dimension-selection__show-more-colors-link__collapsed';
export const expandedLinkClass = 'pdp_dimension-selection__show-more-colors-link__expanded';
export const collapsedContainerClass = 'pdp_dimension-selection__collapsed-on-desktop';
export const sessionStorageKeyIsExpandedPrefix = 'ft5-color-image-tile-is-expanded';
export const selectionValuesForScrolling = 'pdp_dimension-selection__values';
